import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { EChargeType } from 'interfaces/IEditProduct';
import type IProduct from 'interfaces/IProduct';
import MyModal from 'v2/components/Shared/MyModal';
import { Space } from 'v2/components/Shared/Space';
import type { ProductOffer } from 'v2/interfaces/product';

import { Breadcrumb } from './Breadcrumb';
import { Form } from './Form';
import { Header } from './Header';

type LocationState = {
  product?: IProduct;
  offer?: ProductOffer;
};

type Params = {
  productId: string;
};

function EditProductOffer() {
  const location = useLocation<LocationState>();
  const params = useParams<Params>();
  const history = useHistory();
  const product = location.state?.product;
  const offer = location.state?.offer;
  const allowTMBPayment = product?.beta.includes('product_payment_tmb');

  const [modalOpened, setModalOpened] = useState(allowTMBPayment);

  useEffect(() => {
    if (!product || !offer) {
      history.replace('/producer/product/editproduct/' + params.productId + '/sales');
    }
  }, [product, offer, history, params]);

  const chargeType = useMemo(() => {
    if (product?.charge_type === EChargeType.SINGLE) return 'Única';
    return 'Assinatura/Recorrência';
  }, [product]);

  if (!product || !offer) return null;

  const handleModalSubmit = () => {
    setModalOpened(false);
  };

  return (
    <div>
      <Breadcrumb product={product} />
      <Space size={20} axis='vertical' />
      <Header />
      <Space size={20} axis='vertical' />
      <div className='inline-block border border-black/23 px-3.75 py-[7.58px] opacity-50'>
        <strong>Tipo de cobrança:</strong> {chargeType}
      </div>
      <Space size={24} axis='vertical' />
      <Form product={product} offer={offer} />
      <MyModal
        showCancelButton={false}
        buttonOk='OK'
        opened={modalOpened}
        onSubmit={handleModalSubmit}
        onClose={() => {}}
        title={'Atenção'}
      >
        <p className='mb-0!'>
          Se este produto possui o parcelamento via TMB ativo, alterações no produto podem afetar o valor exibido no
          Checkout da TMB ou até remover essa forma de pagamento no Checkout da Eduzz. <br />
          Para garantir o funcionamento correto, comunique seu consultor técnico responsável sempre que fizer qualquer
          alteração neste produto.
        </p>
      </MyModal>
    </div>
  );
}

export { EditProductOffer };
